<template>
  <form-wrapper
    title="Links Settings"
    :hint-images="hint"
  >
    <v-flex xs6>
      <font-settings
        :settings.sync="settings.font"
        title="label:"
        ref="font"
        has-hover-color
      />
    </v-flex>
    <v-flex xs6>
      <settings-switching
        title="Text decoration"
        :types="textDecorationTypes"
        v-model="settings.textDecoration"
        ref="textDecoration"
      />
    </v-flex>

    <reset-submit
      @submit="generateSubmit('link')"
      @reset="resetSettings"
    />
  </form-wrapper>
</template>

<script>
  import BackgroundColorSettings from './../styleSettingsFormComponents/BackgroundColorSettings'
  import FontSettings from './../styleSettingsFormComponents/FontSettings'
  import FormWrapper from './FormWrapper'
  import SettingsSwitching from './../styleSettingsFormComponents/SettingsSwitching'
  import ResetSubmit from './../styleSettingsFormComponents/ResetSubmit'
  import { submitGlobalStyles } from '@/utils/mixins'
  import {
    generateDefaultLinkParams,
    generateMapState
  } from './utils'

  export default {
    name: 'linksSettings',
    components: {
      BackgroundColorSettings,
      FontSettings,
      FormWrapper,
      SettingsSwitching,
      ResetSubmit
    },
    mixins: [submitGlobalStyles],
    data () {
      return {
        textDecorationTypes: [
          'Underline',
          'None'
        ],
        settings: {
          font: generateDefaultLinkParams(),
          textDecoration: 'None'
        },
        hint: [
          {url: '/static/info/Links.png', title: 'Links' },
        ]
      }
    },
    computed: {
      ...generateMapState('link')
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/GeneralSettings/StylesSettings/styleForms/LinksSettings.vue